import { ThemeProvider } from '@mui/material'
import { defaultTheme } from './theme'
import { styled } from '@mui/material/styles'

import IntlProvider from './components/intl-provider/IntlProvider'
import Dashboard from './components/dashboard/DashboardContainer'
import LoginPage from './components/login-page/LoginPageContainer'

const PageContent = styled(Dashboard)({
  maxWidth: 1024,
  margin: '0 auto',
  padding: '0 13px',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
})

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <IntlProvider>
        <PageContent />
        <LoginPage />
      </IntlProvider>
    </ThemeProvider>
  )
}

export default App
